module.exports = __webpack_public_path__ + "media/images/CRUISEHD-a696f94676edaf37c08ca3de39203342.jpg";